/**
 * TODO: validate the email, Email can't contain special character
 * @return True for valid email
 */
const validateEmail = (email: string) => {
  const regexp = new RegExp(
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

  return regexp.test(String(email).toLowerCase());
};

export default validateEmail;
